// A collection of all the interaction types used in all applications. This would be used only
// for interaction icon
export var InteractionIconType;
(function (InteractionIconType) {
    InteractionIconType["Automated"] = "automated";
    InteractionIconType["Call"] = "call";
    InteractionIconType["CallIn"] = "call-in";
    InteractionIconType["CallOut"] = "call-out";
    InteractionIconType["Chat"] = "chat";
    InteractionIconType["Email"] = "email";
    InteractionIconType["EmailIn"] = "email-in";
    InteractionIconType["EmailOut"] = "email-out";
    InteractionIconType["External"] = "external";
    InteractionIconType["Messages"] = "messages";
    InteractionIconType["Notes"] = "notes";
    InteractionIconType["SocialMedia"] = "social-media";
    InteractionIconType["Survey"] = "survey";
})(InteractionIconType || (InteractionIconType = {}));
//# sourceMappingURL=interaction-icon-type.js.map